import { Trans, useTranslation } from 'react-i18next'

import { Button, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const LoadMore = ({ numberOfElementsToShow, totalElements, hasMoreElements, showMore }) => {
  const { t } = useTranslation()
  const startElement = 1

  if (!totalElements) return null

  return (
    <Styles.Container>
      <Text type="bodyMRegular">
        <Trans
          i18nKey="showingRangeOfResults"
          values={{
            startElement,
            numberOfElementsToShow,
            totalElements,
          }}
        >
          Mostrando{' '}
          <strong>
            {{ startElement }}-{{ numberOfElementsToShow }}
          </strong>{' '}
          de <strong>{{ totalElements }}</strong> resultados
        </Trans>
      </Text>
      {hasMoreElements && (
        <Button variant="text" onClick={showMore}>
          {t('Mostrar más resultados')}
        </Button>
      )}
    </Styles.Container>
  )
}

export default LoadMore
